import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import { ChartDimensionState } from '@kaizenplatform/kaizen-chartjs';

export const setIndexReportDimensionKeyState = (indexReportDimensionKeyState: ChartDimensionState[]) =>
  produce((draft: Draft<State>) => {
    draft.indexReportDimensionKeyState.data = indexReportDimensionKeyState;
  });

export const disposeIndexReportDimensionKeyState = () =>
  produce((draft: Draft<State>) => {
    draft.indexReportDimensionKeyState.data = initialState.indexReportDimensionKeyState.data;
  });
